import React, { useState } from "react";
import "./AboutUs.css";
import { ReactComponent as Programming } from "images/goopter-about-us-programming.svg";
import { ReactComponent as LeftBg } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as RightBg } from "images/background/right-box-graphic.svg";
import WaitingFor from "components/Banner/WaitingFor";
import { getData } from "app/data";

export default function Index() {
  return (
    <div className="about-us">
      <div className="page-header">
        <LeftBg className="left-bg" />
        <RightBg className="right-bg" />
        <RedShadow className="red-shadow-bg" />
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <div className="page-header-title">
              <p className="sub-title weaker">
                {getData("about").header.subtitle}
              </p>
              <h2>{getData("about").header.title}</h2>
            </div>
            <div className="text">{getData("about").header.text}</div>
          </div>
          <div className="col-lg-6 col-sm-12 header-image">
            <Programming />
          </div>
        </div>
      </div>
      <div className="background">
        <RightBg className="background-left-bg" />
        <RightBg className="background-right-bg" />
        <div className="contents">
          {getData("about")
            ? getData("about").contents.map((item, index) => {
                return (
                  <div
                    className={index % 2 !== 0 ? "row" : "row flex-row-reverse"}
                  >
                    <div className="col-lg-6 col-sm-12">
                      <div className="text-wrapper">
                        <div className="title">
                          <h2>{item.title}</h2>
                        </div>
                        {item.text
                          ? item.text.map(textItem => (
                              <p key={textItem}>{textItem}</p>
                            ))
                          : null}
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12 image">
                      <div
                        className={`image-wrapper ${
                          item.className ? item.className : null
                        }`}
                      >
                        {item.img ? (
                          <img
                            src={item.img}
                            alt="about-us"
                            className={
                              item.img_className ? item.img_className : null
                            }
                          />
                        ) : item.svg ? (
                          <item.svg />
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
      <WaitingFor />
    </div>
  );
}
